import type { AnimationControls, Variants } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type MonitorCheckIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const CHECK_VARIANTS: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1,
    transition: {
      duration: 0.3,
    },
  },
  animate: {
    pathLength: [0, 1],
    opacity: [0, 1],
    transition: {
      pathLength: { duration: 0.4, ease: 'easeInOut' },
      opacity: { duration: 0.4, ease: 'easeInOut' },
    },
  },
};

const MonitorCheckIconRender = ({ controls, size }: MonitorCheckIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect height="14" rx="2" width="20" x="2" y="3" />
    <path d="M12 17v4" />
    <path d="M8 21h8" />
    <motion.path
      animate={controls}
      d="m9 10 2 2 4-4"
      initial="normal"
      style={{ transformOrigin: 'center' }}
      variants={CHECK_VARIANTS}
    />
  </svg>
);

export type MonitorCheckIconHandle = AnimatedIconHandle;

export const MonitorCheckIcon = withAnimatedIcon(MonitorCheckIconRender, 'MonitorCheckIcon');
